import styled from 'styled-components'


export const CertificateContainer = styled.div`
    display: flex;
    margin-left: 1rem;
    margin-bottom: 0.5rem;
    width:12vw;
    flex-direction: column;
    border: #0090D3 solid 2px;
    z-index: 3;
    position: absolute;
    background-color: white;
    border-radius: 5px;
    top: 95%; 
    left: 55%;
    overflow-y: auto;
    align-items: center;
`

export const ScrollDiv = styled.div`
   display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 150px; 
    overflow-y: auto; 
    align-items: center;
    ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    cursor: pointer;
  }

  ::-webkit-scrollbar-thumb {
    background: #ffff; 
    border-radius: 3px; 
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0; 
    border-radius: 3px; 
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
`

export const CertificateLink = styled.a`
    font-family: 'Inter', sans-serif;;
    color: #0090D3;
    background-color: white;
    margin: 1rem;
    font-size: 1.2vw;
     :hover{
        font-weight: bold
    }
`